import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Instagram, Facebook } from "lucide-react";
import { Wordmark, GoldDivider, Eyebrow } from "../brand";
import { MARKETS_LIST, BUSINESS_INFO } from "../../content/site";

export default function PublicFooter() {
  return (
    <footer className="relative bg-altura-espresso text-altura-ivory noise" data-testid="public-footer">
      <div className="container-editorial py-20">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4 space-y-6">
            <div className="pb-2">
              <Wordmark variant="full" height={130} theme="on-dark" className="max-w-full" />
            </div>
            <p className="text-altura-ivory/75 text-sm leading-relaxed max-w-md">
              A premium international real estate and global investment platform. Ghana is our flagship market, supported by a curated portfolio of international destinations.
            </p>
            <GoldDivider />
            <div className="space-y-2 text-sm text-altura-ivory/75">
              <div className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-altura-gold" /> <a href={`mailto:${BUSINESS_INFO.email_primary}`} className="hover:text-altura-gold">{BUSINESS_INFO.email_primary}</a></div>
              <div className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-altura-gold" /> <a href={`tel:${BUSINESS_INFO.phone_global.replace(/[^\d+]/g, "")}`} className="hover:text-altura-gold">{BUSINESS_INFO.phone_global}</a></div>
              <div className="flex items-start gap-2.5"><MapPin className="h-4 w-4 text-altura-gold mt-0.5" /> <span>9951 Atlantic Blvd. Ste 443<br/>Jacksonville, FL 32225 · USA</span></div>
            </div>
            <div className="flex items-center gap-3 pt-2">
              <a href={BUSINESS_INFO.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook"><Facebook className="h-4 w-4 text-altura-ivory/70 hover:text-altura-gold transition-colors" /></a>
              <a href={BUSINESS_INFO.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram"><Instagram className="h-4 w-4 text-altura-ivory/70 hover:text-altura-gold transition-colors" /></a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <Eyebrow className="text-altura-gold">Explore</Eyebrow>
            <ul className="mt-5 space-y-2.5 text-sm text-altura-ivory/75">
              <li><Link to="/explore-ghana" className="hover:text-altura-gold">Ghana (Flagship)</Link></li>
              <li><Link to="/opportunities" className="hover:text-altura-gold">Opportunities</Link></li>
              <li><Link to="/learning-center" className="hover:text-altura-gold">Learning Center</Link></li>
              <li><Link to="/resources" className="hover:text-altura-gold">Resources</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <Eyebrow className="text-altura-gold">Markets</Eyebrow>
            <ul className="mt-5 space-y-2.5 text-sm text-altura-ivory/75">
              {MARKETS_LIST.map((m) => (
                <li key={`footer-market-${m.slug}`}><Link to={`/markets/${m.slug}`} className="hover:text-altura-gold">{m.name}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <Eyebrow className="text-altura-gold">Company</Eyebrow>
            <ul className="mt-5 space-y-2.5 text-sm text-altura-ivory/75">
              <li><Link to="/about" className="hover:text-altura-gold">About</Link></li>
              <li><Link to="/contact" className="hover:text-altura-gold">Contact</Link></li>
              <li>
                <span
                  className="inline-flex items-center gap-2 text-altura-ivory/55 cursor-not-allowed select-none whitespace-nowrap"
                  data-testid="footer-global-partners-soon"
                  aria-disabled="true"
                >
                  Global Partners
                  <span className="text-[9px] uppercase tracking-[0.14em] text-altura-gold/85 border border-altura-gold/35 rounded-full px-1.5 py-[1px] leading-none">Soon</span>
                </span>
              </li>
              <li><Link to="/altura-command/login" className="hover:text-altura-gold" data-testid="footer-command-center-link">Command Center</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <Eyebrow className="text-altura-gold">Services</Eyebrow>
            <ul className="mt-5 space-y-2.5 text-sm text-altura-ivory/75">
              <li><Link to="/consultation" className="hover:text-altura-gold">Consultation</Link></li>
              <li><Link to="/global-link" className="hover:text-altura-gold">Join The Global Link</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col-reverse gap-4 border-t border-altura-ivory/10 pt-6 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-xs text-altura-ivory/50" data-testid="footer-copyright">
              © 2026 Altura Global Real Estate (&ldquo;Altura Global RE&rdquo;). All rights reserved.
            </p>
            <div className="mt-2 flex flex-wrap gap-4 text-[11px] text-altura-ivory/60">
              <Link to="/terms" className="hover:text-altura-gold" data-testid="footer-terms">Terms &amp; Privacy</Link>
              <Link to="/tgl-terms" className="hover:text-altura-gold" data-testid="footer-tgl-terms">TGL Terms</Link>
              <Link to="/contact" className="hover:text-altura-gold">Contact</Link>
            </div>
          </div>
          <p className="text-[11px] text-altura-ivory/45 max-w-2xl">
            Altura Global does not provide legal, tax, immigration, or financial advice. All investments carry risk. We coordinate with licensed local professionals in each market.
          </p>
        </div>
      </div>
    </footer>
  );
}
